import {inject, Injectable} from '@angular/core';
import {NonNullableFormBuilder} from '@angular/forms';
import {BehaviorSubject, debounceTime, distinctUntilChanged, map, shareReplay, startWith} from 'rxjs';
import {Store} from '@ngxs/store';
import {SearchState} from '../+state/search/state';

export interface SearchFilter {
  online: 'all' | boolean;
  [key: string]: boolean | string | number;
}

@Injectable({
  providedIn: 'root'
})
export class SearchInputViewService {
  private readonly store = inject(Store);
  private readonly query = this.store.selectSnapshot(SearchState.getQuery);
  private readonly searchFiltersSubject = new BehaviorSubject<SearchFilter>({
    online: 'all'
  });
  private readonly fb = inject(NonNullableFormBuilder);
  searchTermFormControl = this.fb.control(this.query ?? '');
  readonly searchTermChanged$ = this.searchTermFormControl.valueChanges.pipe(
    debounceTime(650),
    map(value => value.trim()),
    distinctUntilChanged(),
    startWith(''),
    shareReplay({ refCount: false, bufferSize: 1}),
  );

  setFilters(filters: SearchFilter) {
    const currentFilters = this.searchFiltersSubject.value;
    this.searchFiltersSubject.next({
      ...currentFilters,
      ...filters
    });
  }
}
